export default __webpack_public_path__ + "static/zak-37a16a7e9045d9ddd0a0444142e55161.jpg";